import React from 'react';
import useSWR from 'swr';
import { Icon } from '@iconify/react/dist/iconify.js';
import { Link, useParams } from 'react-router-dom';
import { useFetch } from '../hook/useFecth';
import useDialog from '../hook/useDialog';
import server from '../services/server';
import { Modal } from 'react-bootstrap';
import { useFormik } from 'formik';
import useErrors from '../hook/useErrors';
import AddressInput from './AddressInput';

function EnderecosListLayer({ mutate: mutateCliente }) {
    const { id: clienteId } = useParams();
    const { handleOpen } = useDialog('endereco');
    const { data: enderecos = [], mutate: mutateEnderecos, isFetching } = useFetch(
        clienteId ? `cliente/${clienteId}/endereco` : null
    );

    if (!clienteId) return null;

    return (
        <div className="tab-pane fade" id="pills-add-address" role="tabpanel" aria-labelledby="pills-add-address-tab" tabIndex={0}>
            <div className="card border-0">
                <div className="card-header bg-white d-flex align-items-center justify-content-between border-bottom">
                    <h6 className="mb-0">Endereços</h6>
                    <button
                        type="button"
                        className="btn btn-primary btn-sm"
                        onClick={() => handleOpen()}
                    >
                        <Icon icon="mdi:plus" className="me-2" />
                        Adicionar endereço
                    </button>
                </div>
                <div className="card-body">
                    {isFetching ? (
                        <div className="text-center py-4 text-muted">Carregando...</div>
                    ) : !enderecos?.length ? (
                        <p className="text-muted mb-0">Nenhum endereço cadastrado.</p>
                    ) : (
                        <div className="table-responsive">
                            <table className="table table-hover mb-0">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Descrição</th>
                                        <th>Logradouro</th>
                                        <th>Nº</th>
                                        <th>Cidade / UF</th>
                                        <th className="text-end">Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {enderecos.map((end) => (
                                        <tr key={end.id}>
                                            <td className={`${end.principal ? 'text-success' : ''}`}>{end.id}</td>
                                            <td className={`${end.principal ? 'text-success' : ''}`}>{end.descricao || '-'}</td>
                                            <td className={`${end.principal ? 'text-success' : ''}`}>{end.logradouro || end.rua || '-'}</td>
                                            <td className={`${end.principal ? 'text-success' : ''}`}>{end.numero || '-'}</td>
                                            <td className={`${end.principal ? 'text-success' : ''}`}>
                                                {end.cidade || '-'} / {end.estado || '-'}
                                            </td>

                                            <td className="text-end">
                                                <div className="d-flex align-items-end gap-10 justify-content-end">


                                                    <button
                                                        onClick={() => handleOpen(end.id)}

                                                        className="bg-success-focus text-success-600 bg-hover-success-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                    >
                                                        <Icon icon="lucide:edit" className="menu-icon" />
                                                    </button>
                                                </div>

                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
            <FormEnderecoModal clienteId={clienteId} mutate={mutateEnderecos} onClose={mutateCliente} />
        </div>
    );
}

function FormEnderecoModal({ clienteId, mutate, onClose }) {
    const { setErrors, toast } = useErrors();
    const { id: enderecoId, open: show, handleClose } = useDialog('endereco');
    const { data } = useFetch(Boolean(enderecoId) ? `cliente/${clienteId}/endereco/${enderecoId}` : null)

    const { getFieldProps, errors, isSubmitting, isValid, handleSubmit, touched, values, setValues, setFieldValue } = useFormik({
        initialValues: {
            zipcode: '',
            state: '',
            city: '',
            address: '',
            neighborhood: '',
            number: '',
            complement_address: '',
            descricao: '',
            principal: false,
            pais: 'Brasil',
        },
        validateOnMount: true,
        validateOnChange: true,
        onSubmit: async (vals, { setSubmitting, resetForm }) => {
            try {
                setSubmitting(true);
                const payload = {
                    cep: vals.zipcode,
                    logradouro: vals.address,
                    rua: vals.address,
                    bairro: vals.neighborhood,
                    numero: vals.number,
                    complemento: vals.complement_address || undefined,
                    cidade: vals.city,
                    estado: vals.state,
                    pais: vals.pais || 'Brasil',
                    principal: vals.principal,
                    descricao: vals.descricao || undefined,
                };

                if (enderecoId) {
                    await server.put(`cliente/${clienteId}/endereco/${enderecoId}`, payload);
                    toast.success('Endereço alterado com sucesso.');
                } else {
                    await server.post(`cliente/${clienteId}/endereco`, payload);
                    toast.success('Endereço cadastrado com sucesso.');
                }

                mutate();
                onClose?.();
                handleClose();
                resetForm();
            } catch (error) {
                setErrors(error);
            } finally {
                setSubmitting(false);
            }
        },
    });

    React.useEffect(() => {
        if (data) {
            setValues({
                zipcode: data.cep || '',
                address: data.logradouro || data.rua || '',
                neighborhood: data.bairro || '',
                number: data.numero || '',
                complement_address: data.complemento || '',
                city: data.cidade || '',
                state: data.estado || '',
                pais: data.pais || 'Brasil',
                principal: data.principal || false,
                descricao: data.descricao || '',
            }, true);
        }
    }, [data]);

    if (!show) return null;

    return (
        <Modal size='lg' show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title className="text-md">{enderecoId ? 'Editar endereço' : 'Novo endereço'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form onSubmit={handleSubmit}>
                    <div className="row mb-3">
                        <div className="col-12 mb-3">
                            <label className="form-label">Descrição</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Ex: Residencial, Comercial"
                                {...getFieldProps('descricao')}
                            />
                        </div>
                        <div className="col-12 mb-3">
                            <AddressInput
                                onChangeAddress={(addr) => setValues({ ...values, ...addr })}
                                error={errors.zipcode}
                                touched={touched.zipcode}
                                {...getFieldProps('zipcode')}
                            />
                        </div>
                        <div className="col-md-6 mb-3">
                            <label className="form-label">Logradouro</label>
                            <input
                                type="text"
                                readOnly
                                className="form-control"
                                placeholder="Logradouro"
                                {...getFieldProps('address')}
                            />
                        </div>
                        <div className="col-md-6 mb-3">
                            <label className="form-label">Bairro</label>
                            <input
                                type="text"
                                readOnly
                                className="form-control"
                                placeholder="Bairro"
                                {...getFieldProps('neighborhood')}
                            />
                        </div>
                        <div className="col-md-4 mb-3">
                            <label className="form-label">Cidade</label>
                            <input
                                type="text"
                                readOnly
                                className="form-control"
                                placeholder="Cidade"
                                {...getFieldProps('city')}
                            />
                        </div>
                        <div className="col-md-3 mb-3">
                            <label className="form-label">Estado</label>
                            <input
                                type="text"
                                readOnly
                                className="form-control"
                                placeholder="UF"
                                {...getFieldProps('state')}
                            />
                        </div>
                        <div className="col-md-3 mb-3">
                            <label className="form-label">Número *</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Número"
                                required
                                {...getFieldProps('number')}
                            />
                        </div>
                        <div className="col-md-12 mb-3">
                            <label className="form-label">Complemento</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Complemento"
                                {...getFieldProps('complement_address')}
                            />
                        </div>
                    </div>

                    <div className="d-flex justify-content-end gap-2">
                        <div className="form-switch  switch-primary   d-flex align-items-center gap-3">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                role="switch"
                                id="switch2"
                                defaultChecked={false}
                                checked={values.principal}
                                {...getFieldProps('principal')}
                            />
                            <label
                                className="form-check-label line-height-1 fw-medium text-secondary-light"
                                htmlFor="switch2"
                            >
                                Principal
                            </label>
                        </div>
                        <button type="button" className="btn btn-outline-secondary" onClick={handleClose}>
                            Cancelar
                        </button>
                        <button type="submit" className="btn btn-primary" disabled={isSubmitting || !isValid}>
                            {isSubmitting ? 'Salvando...' : 'Salvar'}
                        </button>
                    </div>
                </form>
            </Modal.Body>
        </Modal>
    );
}

export default EnderecosListLayer;
